import type { Effect, EffectType } from './index';

export const EFFECT_TYPES = {
  DROP_SHADOW: 'drop-shadow',
  INNER_SHADOW: 'inner-shadow',
  LAYER_BLUR: 'layer-blur',
  BACKGROUND_BLUR: 'background-blur',
} as const;

// Derived from `EFFECT_TYPES` so adding a new effect type only touches the map
// above — the schema's allowed-types list updates automatically.
export const ALL_EFFECT_TYPES = Object.values(EFFECT_TYPES) as EffectType[];

type EffectDefaults = { [K in EffectType]: Omit<Extract<Effect, { type: K }>, 'id'> };

// Defaults mirror Figma's add-effect: 0/4/4/0 black @ 25% (`#00000040`).
export const DEFAULT_EFFECT_BY_TYPE: EffectDefaults = {
  [EFFECT_TYPES.DROP_SHADOW]: {
    type: EFFECT_TYPES.DROP_SHADOW,
    visible: true,
    x: 0,
    y: 4,
    blur: 4,
    spread: 0,
    color: { custom: '#00000040' },
  },
  [EFFECT_TYPES.INNER_SHADOW]: {
    type: EFFECT_TYPES.INNER_SHADOW,
    visible: true,
    x: 0,
    y: 4,
    blur: 4,
    spread: 0,
    color: { custom: '#00000040' },
  },
  [EFFECT_TYPES.LAYER_BLUR]: {
    type: EFFECT_TYPES.LAYER_BLUR,
    visible: true,
    blur: 4,
  },
  [EFFECT_TYPES.BACKGROUND_BLUR]: {
    type: EFFECT_TYPES.BACKGROUND_BLUR,
    visible: true,
    blur: 4,
  },
};
